module.exports = __webpack_public_path__ + "static/img/course1.01ed930.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/course1.png
// module id = 3xO2
// module chunks = 63